import ApiUrls from "../../../service/api/ApiUrls";
import ApiService from "../../../service/api/ApiService";
import ShowToast from "../../../widget/common/ui/Toast";
import {
  GeoLocationModel,
  LocationGeoResult,
} from "../../../model/country_state_city_area/GeoLocationModel";

const CountryStateCityAreaProvider = new (class CountryStateCityAreaProvider {
  getGeoListAPI = async (params: {
    flagId: string;
    countryId: string;
    stateId: string;
    cityId: string;
  }): Promise<Array<LocationGeoResult> | null> => {
    ApiUrls.init();

    const url: string = `${ApiUrls.baseUrl}geo/getCountryStateCityAreaList`;
    const body: any = {
      flag: params.flagId,
      country_id: params.countryId,
      state_id: params.stateId,
      city_id: params.cityId,
      area_id: "0",
    };

    const response: any = await ApiService.postApi(url, body);
    if (response != null) {
      if (response["success"] === "1") {
        const geoLocationModel: GeoLocationModel = response;
        const locationGeoResult: Array<LocationGeoResult> | undefined =
          geoLocationModel?.result?.location_geo_result;

        return locationGeoResult ?? null;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    }

    return null;
  };
})();

export default CountryStateCityAreaProvider;
